import { Button } from "../../bits/Button/Button";
import styles from "./FindClinicianCard.module.scss";
import { useHistory } from "react-router-dom";
import { IClient } from "intake_shared/src/types";

export default function FindClinicianCard({ client }: { client: IClient }) {
    const history = useHistory();

    return (
        <div className={styles.findClinicianWrapper}>
            <div className={styles.findClinicianText}>
                <p className={styles.findClinicianTextTitle}>Find a clinician</p>
                <p className={styles.findClinicianTextDescription}>
                    Do you want to find and match a clinician that meets the needs of
                    this client?
                </p>
            </div>
            <div>
                <Button
                    onClick={() => {
                        history.push({
                            pathname: "/v2/find-clinician",
                            search: `?client=${client.id}`,
                            state: { client },
                        });
                    }}
                >
                    Find a clinician
                </Button>
            </div>
        </div>
    );
}
